import React, { useState, useEffect, useRef } from 'react';
import {
  Container,
  Typography,
  Button,
  TextField,
  Box,
  Paper,
  InputAdornment,
} from '@mui/material';
import {
  Search as SearchIcon,
  Receipt as ReceiptIcon,
  Add as AddIcon,
  ArrowBack as ArrowBackIcon,
} from '@mui/icons-material';
import TTareas from '../GestionDeTareas/TTareas';
import { obtenerTareasFactura } from '../../actions/CobranzasAction';
import { useStateValue } from '../../contexto/store';
import { useHistory } from 'react-router-dom';
export function HistorialDeTareasDeFactura(props) {
  const mounted = useRef(true);
  const [term, setTerm] = useState('');
  const [rows, setRows] = useState([]);
  const factu = [props.location.state];
  const history = useHistory();
  const volver = () => {
    props.history.goBack();
  };
  const nuevaTareaFactura = () => {
    factu['facturas'] = true;
    history.push({ pathname: '/nuevaTarea', state: factu });
  };
  //eslint-disable-next-line
  const [{ sesionUsuario }, dispatch] = useStateValue();
  useEffect(() => {
    if (mounted.current) {
      obtenerTareasFactura(factu[0].id).then((response) => {
        if (response.status === 200) {
          setRows(response.data);
        }
      });
    }
    return function cleanup() {
      mounted.current = false;
    };
  });
  return (
    <Container maxWidth="xl" sx={{ py: 4 }}>
      {/* Header */}
      <Paper
        elevation={0}
        sx={{
          background: 'linear-gradient(135deg, #1976d2 0%, #0d47a1 100%)',
          borderRadius: 2,
          p: 3,
          mb: 3,
          position: 'relative',
          overflow: 'hidden',
        }}
      >
        <Box
          sx={{
            position: 'absolute',
            right: -20,
            top: -20,
            opacity: 0.2,
          }}
        >
          <ReceiptIcon sx={{ fontSize: 120, transform: 'rotate(-15deg)' }} />
        </Box>
        <Box sx={{ position: 'relative' }}>
          <Typography
            variant="h4"
            fontWeight={700}
            color="white"
            gutterBottom
            sx={{ display: 'flex', alignItems: 'center', gap: 2 }}
          >
            <ReceiptIcon sx={{ fontSize: 40 }} />
            Historial de Tareas
          </Typography>
          <Typography variant="body1" color="rgba(255,255,255,0.9)">
            Factura Nro: {factu[0].nrocomprobante}
          </Typography>
        </Box>
      </Paper>

      {/* Action Buttons */}
      <Paper elevation={1} sx={{ p: 2, mb: 3, borderRadius: 2 }}>
        <Box sx={{ display: 'flex', gap: 2, flexWrap: 'wrap' }}>
          <Button
            onClick={nuevaTareaFactura}
            variant="contained"
            color="primary"
            startIcon={<AddIcon />}
            sx={{
              borderRadius: 2,
              textTransform: 'none',
              fontWeight: 600,
              px: 3,
            }}
          >
            Nueva Tarea
          </Button>
          <Button
            onClick={volver}
            variant="outlined"
            color="primary"
            startIcon={<ArrowBackIcon />}
            sx={{
              borderRadius: 2,
              textTransform: 'none',
              fontWeight: 600,
              px: 3,
            }}
          >
            Volver
          </Button>
        </Box>
      </Paper>

      {/* Search Bar */}
      <Paper elevation={1} sx={{ p: 2, mb: 3, borderRadius: 2 }}>
        <TextField
          fullWidth
          variant="outlined"
          placeholder="Buscar tareas..."
          value={term}
          onChange={(e) => setTerm(e.target.value)}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon color="action" />
              </InputAdornment>
            ),
          }}
          sx={{
            '& .MuiOutlinedInput-root': {
              borderRadius: 2,
            },
          }}
        />
      </Paper>

      {/* Tasks Table */}
      <Paper elevation={2} sx={{ borderRadius: 2, overflow: 'hidden' }}>
        <TTareas
          rows={rows}
          termc={term}
          history={props.history}
          id={factu[0].TipoVisitante}
          factura={true}
        />
      </Paper>
    </Container>
  );
}
